export const splitByNl = (input) => input != null ? input.replace(/\r?\n/g, '<br>') : ""
